import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-cookie-consent",
  imports: [ButtonModule, RouterLink],
  templateUrl: "./cookie-consent.component.html",
  styleUrl: "./cookie-consent.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentComponent {
  protected visible = signal(!localStorage.getItem("cookie_consent"));

  accept() {
    localStorage.setItem("cookie_consent", "accepted");
    this.visible.set(false);
  }

  reject() {
    localStorage.setItem("cookie_consent", "rejected");
    this.visible.set(false);
  }
}
